//MSISDNs
export const GET_MSISDN = 'get:msisdn';
export const REG_MSISDN = 'register:msisdn';
export const ACTIVATE_DEACTIVATE_MSISDN = 'update:msisdn-status-all';
export const UNREG_MSISDN = 'unregister:msisdn';
export const UPDATE_MSISDN_STATUS = 'update:msisdn-status';
export const UPDATE_MSISDN = 'update:msisdn';
export const GET_OVERVIEW = 'get:msisdn-overview';

export const VIEW_MSISDN_LOCATIONS = 'get:locations';

export const GET_HOURS = 'get:hours';

//FCM
export const SEND_FCM_NOTIFICATION = 'send:fcm-notification';
export const SEND_FCM = 'send:fcm';

//COMPANIES
export const REG_COMPANY = 'register:company'
export const GET_COMPANY = 'get:company'
export const GET_ALL_COMPANIES = 'get:company-all'
export const DELETE_COMPANY = 'delete:company-all'
export const UPDATE_COMPANY = 'update:company'
export const UPDATE_COMPANY_ALL = 'update:company-all'


//Geofences
export const GET_GEOFENCE = 'get:geofence';
export const REG_GEOFENCE = 'register:geofence';
export const UPDATE_GEOFENCE = 'update:geofence';
export const DEL_GEOFENCE = 'delete:geofence';

export const MANAGE_GEOFENCE_ASSIGNMENTS = 'manage-assignments:geofence';

//Users
export const GET_USERS = 'get:users';
export const GET_USERS_ALL = 'get:users-all';
export const CREATE_USERS = 'create:user';
export const CREATE_USERS_ALL = 'create:user-all';
export const UPDATE_USERS = 'update:user';
export const DELETE_USERS = 'delete:users';

//Locations
export const REQ_LOCATION_UPDATE = 'request:locations'

//Settings
export const GET_SETTINGS = 'get:settings'
export const SET_COMPANY_SETTINGS = 'set:company-settings'
export const SET_MSISDN_SETTINGS = 'set:msisdn-settings'
export const SET_GLOBAL_SETTINGS = 'set:global-settings'

// Timeline
export const GET_TIMELINE = 'get:timeline'
export const MANAGE_TIMELINE = 'manage:timeline'
export const MANAGE_TIMELINE_ALL = 'manage:timeline-all'

//Billing
export const GET_BILLING = 'get:billing';
export const GET_BILLING_ALL = 'get:billing-all';
export const UPDATE_BILLING = 'update:billing';
export const UPDATE_BILLING_ALL = 'update:billing-all';
export const TOP_UP_BALANCE = 'top-up:balance';
export const TOP_UP_BALANCE_ALL = 'top-up:balance-all';
export const GET_BUNDLES = 'get:bundles';
export const GET_BUNDLES_ALL = 'get:bundles-all';
export const UPDATE_BUNDLES_ALL = 'update:bundles-all';
export const GET_BILLING_REPORT = 'get:billing-report';
export const GET_BILLING_REPORT_ALL = 'get:billing-report-all';
export const ADJUST_BALANCE = 'adjust:balance';

//Trial
export const MANAGE_TRIAL = 'manage:trial';
export const EXTEND_TRIAL = 'extend:trial';

// Notifications
export const MANAGE_NOTIFICATIONS = 'manage:notifications';